import { useState, useEffect } from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'
import { HelmetProvider, Helmet } from 'react-helmet-async'
import Layout from './layout/Layout'
import Dashboard from './pages/dashboard/Dashboard'
import Bots from './pages/bots/Bots'
import WidgetManager from './pages/widget/WidgetManager'
import Profile from './pages/profile/Profile'
import Billing from './pages/billing/Billing'
import Support from './pages/support/Support'
import Leads from './pages/leads/Leads'
import Signin from './pages/Signin'
import LandingPage from './pages/landing/LandingPage'
import About from './pages/about/About'
import Products from './pages/products/Products'
import Careers from './pages/careers/Careers'
import PageNotFound from './pages/PageNotFound'
import { AuthProvider } from './contexts/AuthContext'
import { ChatProvider } from './contexts/ChatContext'
import { ThemeProvider } from './contexts/ThemeContext'
import { ToastContainer } from 'react-toastify'

function App() {
  const [isLoading, setIsLoading] = useState(true)
  const location = useLocation()

  useEffect(() => {
    // Check if page is already loaded (for faster subsequent loads)
    const isPageLoaded = document.readyState === 'complete'

    if (isPageLoaded) {
      // If page is already loaded, show loader for minimal time
      const timer = setTimeout(() => {
        setIsLoading(false)
      }, 300)
      return () => clearTimeout(timer)
    } else {
      // Wait for page load, but with a maximum timeout
      const handleLoad = () => {
        setTimeout(() => {
          setIsLoading(false)
        }, 300)
      }

      window.addEventListener('load', handleLoad)

      // Fallback timeout (max 800ms)
      const fallbackTimer = setTimeout(() => {
        setIsLoading(false)
      }, 800)

      return () => {
        window.removeEventListener('load', handleLoad)
        clearTimeout(fallbackTimer)
      }
    }
  }, [])



  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-secondary-900 via-secondary-800 to-primary-900 flex items-center justify-center">
        <div className="text-center">
          <div className="ai-loading mx-auto mb-4"></div>
          <h2 className="text-2xl font-bold ai-text-gradient mb-2 text-white">Talkida Technologies</h2>
          <p className="text-secondary-400">Initializing your AI chatbot platform...</p>
        </div>
      </div>
    )
  }

  return (
    <HelmetProvider>
      {/* Global Clarity Analytics */}
      <Helmet>
        <script type="text/javascript" dangerouslySetInnerHTML={{
          __html: `
            (function(c,l,a,r,i,t,y){
                c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window, document, "clarity", "script", "u0sqomj00c");
          `
        }} />
      </Helmet>
      <ThemeProvider>
        <AuthProvider>
          <ToastContainer stacked={true} />
          <ChatProvider>
            <div className="App min-h-screen bg-gradient-to-br from-secondary-900 via-secondary-800 to-primary-900">
              <Routes>
                {/* Public Routes */}
                <Route path="/" element={<LandingPage />} />
                <Route path="/signin" element={<Signin />} />
                <Route path="/about" element={<About />} />
                <Route path="/products" element={<Products />} />
                <Route path="/careers" element={<Careers />} />

                {/* Protected Dashboard Routes */}
                <Route path="/dashboard" element={<Layout />}>
                  <Route index element={<Dashboard />} />
                  <Route path="bots" element={<Bots />} />
                  <Route path="widgets" element={<WidgetManager />} />
                  <Route path="leads" element={<Leads />} />
                  <Route path="profile" element={<Profile />} />
                  {/* <Route path="billing" element={<Billing />} /> */}
                  <Route path="support" element={<Support />} />
                </Route>

                <Route path="*" element={<PageNotFound />} />
              </Routes>
            </div>
          </ChatProvider>
        </AuthProvider>
      </ThemeProvider>
    </HelmetProvider>
  )
}

export default App
